import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

interface MarketFiltersWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

const setMarketFiltersWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            padding: ${theme.star.padding.medium} ${theme.star.padding.medium} 0;
            background-color: ${theme.star.marketHeader.bgColorSecondary};
            margin-top: 8px;
            @media ${theme.star.mediaQuery.tablet} {
                margin: 8px 8px 0;
                border-radius: ${theme.star.radius.medium} ${theme.star.radius.medium} 0 0;
            }
        `;
    }
    return css`
        padding: ${theme.star.padding.medium} 0 ${theme.star.padding.medium} ${theme.star.padding.medium};
    `;
};

export const MarketFiltersWrapper = withConfig(theme => styled('div', { label: 'MarketFiltersWrapper' })<MarketFiltersWrapperPropsType>`
    ${({ variant }): SerializedStyles => setMarketFiltersWrapper(variant, theme)}
`);
